"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ToolBar = function (props) {
    var _a = (0, react_1.useState)(false), hover = _a[0], setHover = _a[1];
    var _b = (0, react_1.useState)(false), showNav = _b[0], setShowNav = _b[1];
    var refItems = (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)(0), leftContentWidth = _c[0], setLeftContentWidth = _c[1];
    (0, react_1.useEffect)(function () {
        var _count = 0;
        refItems.current &&
            refItems.current.childNodes.forEach(function (el) {
                _count += el.offsetWidth;
            });
        setLeftContentWidth(_count);
    }, [props.items]);
    var _d = (0, react_1.useState)(window.innerWidth), windowWidth = _d[0], setWindowWidth = _d[1];
    var onResize = function (event) {
        event.target.outerWidth &&
            setWindowWidth(event.target.outerWidth);
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener("resize", onResize, true);
        return function () {
            window.removeEventListener("resize", onResize, true);
        };
    }, []);
    var refLeft = (0, react_1.useRef)(null);
    var scrollToolBar = function (value) {
        refItems && refItems.current &&
            refItems.current.scroll(refItems.current.scrollLeft + value, 0);
    };
    (0, react_1.useEffect)(function () {
        setTimeout(function () {
            var _left = refLeft.current.offsetWidth;
            setShowNav(leftContentWidth > _left);
        }, 200);
    }, [hover, windowWidth]);
    return (react_1.default.createElement("div", { className: "toolbar", onMouseOver: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); }, onClick: function () { return props.onClick && props.onClick(); } },
        react_1.default.createElement("div", { className: "left", ref: refLeft },
            showNav &&
                react_1.default.createElement("div", { className: "nav", onClick: function () { scrollToolBar(-70); } },
                    react_1.default.createElement("i", { className: "ppi ppi-chevron-left" })),
            react_1.default.createElement("div", { className: "items", ref: refItems }, props.items && props.items.length > 0 &&
                props.items.map(function (item, index) {
                    return (react_1.default.createElement("span", { key: index, className: "item ".concat(item.active ? 'active' : ''), onClick: function () { return !item.active && item.onClick(); } }, item.label));
                }))),
        props.right &&
            react_1.default.createElement("div", { className: "right" },
                showNav &&
                    react_1.default.createElement("div", { className: "nav", onClick: function () { scrollToolBar(70); } },
                        react_1.default.createElement("i", { className: "ppi ppi-chevron-right" })),
                props.right(hover))));
};
exports.default = ToolBar;
